const emotionDumpArr = [] as string[];
const emotionDump = document.getElementById("emotionDump");

const wrapInLayer = (rule: string, layer: string = "frameworks") => {
  return `@layer ${layer} { ${rule} } \n`;
};

const wrapAndDumpStyleInLayer = (StyleSheet: ExtendedCSSStyleSheet, layer: string = "frameworks") => {
  if (!emotionDump) return;

  const rulesLength = StyleSheet.cssRules.length;
  for (let i = 0; i < rulesLength; i++) {
    if (!emotionDumpArr.includes(StyleSheet.cssRules[i].cssText)) {
      emotionDump.innerHTML += wrapInLayer(StyleSheet.cssRules[i].cssText, layer);
      emotionDumpArr.push(StyleSheet.cssRules[i].cssText);
    }
  }
  for (let i = 0; i < rulesLength; i++) {
    StyleSheet.deleteRule(0);
  }
};

const observeStyleInjection = () => {
  const styleSheets = document.styleSheets;
  for (let i = 0; i < styleSheets.length; i++) {
    const styleSheet: ExtendedCSSStyleSheet = styleSheets[i];
    const sheetNode = styleSheet.ownerNode as HTMLElement;
    const dataIsListened = sheetNode.dataset?.isListened;

    const dataEmotion = sheetNode.dataset?.emotion;
    if (dataEmotion && !dataIsListened) {
      sheetNode.setAttribute("data-is-listened", "true");
      wrapAndDumpStyleInLayer(styleSheet, dataEmotion === "mui-global" ? "defaults" : "frameworks");
      styleSheet.onInsertRule = (rule, index) => {
        if (rule.startsWith("@layer")) return;
        wrapAndDumpStyleInLayer(styleSheet, dataEmotion === "mui-global" ? "defaults" : "frameworks");
      };
    }

    if (sheetNode.dataset.cke && !dataIsListened) {
      sheetNode.setAttribute("data-is-listened", "true");
      sheetNode.innerHTML = wrapInLayer(sheetNode.innerHTML, "frameworks");
    }
  }
};

export function observeHeadChanges() {
  const originalInsertRule = CSSStyleSheet.prototype.insertRule;

  // Override the insertRule method
  CSSStyleSheet.prototype.insertRule = function (this: ExtendedCSSStyleSheet, rule: string, index: number) {
    const result = originalInsertRule.call(this, rule, index);

    if (typeof this.onInsertRule === "function") {
      this.onInsertRule(rule, index);
    }

    return result;
  };

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
        observeStyleInjection();
      }
    }
  });

  observer.observe(document.head, { childList: true });
}

interface ExtendedCSSStyleSheet extends CSSStyleSheet {
  onInsertRule?: (rule: string, index: number) => void;
}
